import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Device } from '@iotv/datamodel-core';
import { isPosition } from '@iotv/iotv-v3-types';
import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { GoogleMapAPIMapTypeIds, useGoogleMap } from '../../../GoogleMapV4';
import { geoObjectCodec, isShimmedGeoObject } from '../../../GoogleMapV4/mapfns/ObjectConversion/validGeoObjectShims';
import { ShowDefinedEntriesOnlyOpts, UserTransactionType } from '../../../types/AppTypes';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
import PhotosCard from '../../cards/PhotosCard';
const debug = process.env.REACT_APP_DEBUG && false;
const DetailsTab = (props) => {
    const { device, transactionFunctions, userFunctions, mostProximateCustomer, allowedActions, isSmallView } = props;
    const [addedDevice, setAddedDevice] = useState(device);
    const hasLocation = isPosition(addedDevice.location);
    const { dispatch, map, state: { places }, components: { PortalDiv }, } = useGoogleMap({
        showDrawingTools: false,
        functions: {},
        providedState: {
            options: { zoom: 16, center: hasLocation ? device.location : null, mapTypeId: GoogleMapAPIMapTypeIds.terrain },
        },
    });
    useEffect(() => {
        debug && console.log('Device Detail tab used effect on places');
        const proxyDevice = places.find((p) => p.id === device.id);
        if (isShimmedGeoObject(proxyDevice)) {
            const rehydratedDevice = geoObjectCodec.fromGeoObject(proxyDevice);
            rehydratedDevice && setAddedDevice(new Device(rehydratedDevice));
            debug && console.log('Device Detail got shimmed geoObject', rehydratedDevice);
        }
        else {
            debug && console.log('Device Detail not shimmed', proxyDevice);
        }
    }, [places]);
    useEffect(() => {
        if (device && hasLocation) {
            const proxyDevice = geoObjectCodec.toGeoObject(device);
            if (proxyDevice) {
                /** As of 2024 07 DetailCard will reset edited to false on external change like this, which prevents the user saving */
                proxyDevice.metadata = { ...proxyDevice.metadata, lastUpdatedMs: Date.now() };
                const action = {
                    type: 'update',
                    value: { subType: 'addPlaceToDatalayer', place: proxyDevice },
                };
                dispatch(action);
            }
        }
    }, [device]);
    return (_jsxs(Stack, { direction: isSmallView ? 'column' : 'row', gap: 1, children: [_jsx(Stack, { minWidth: "50%", children: _jsx(ObjectDetailCard, { matchedPrimary: addedDevice, mostProximateCustomer: mostProximateCustomer, allowedActions: allowedActions, definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes, userFunctions: userFunctions, transactionFunctions: transactionFunctions }) }, "details"), _jsxs(Stack, { flexGrow: 1, gap: 1, children: [isPosition(device.location) && map.current ? (_jsxs(Stack, { height: "80cqh", children: [PortalDiv, map.current] }, "map")) : null, _jsx(Stack, { children: _jsx(PhotosCard, { matchedPrimary: device, userFunctions, transactionFunctions, actions: [UserTransactionType.CREATE] }) }, "photos")] }, "aside")] }));
};
export default DetailsTab;
